import styled from '@emotion/native';
import { useTheme } from '@emotion/react';
import {
  type DrawerNavigationOptions,
  DrawerToggleButton,
} from '@react-navigation/drawer';
import { BASE_SIZE, FONT_FAMILY, FONT_SIZE } from 'design-system/theme';
import { type DrawerType, useDrawerType } from 'hooks/useDrawerType';
import type { TextStyle, ViewStyle } from 'react-native';

const drawerLabelStyle: TextStyle = {
  fontFamily: FONT_FAMILY.regular,
  fontSize: FONT_SIZE.body,
};

const headerTitleStyle: TextStyle = {
  fontFamily: FONT_FAMILY.regular,
  fontSize: FONT_SIZE.heading,
};

export const hiddenDrawerItemStyle: ViewStyle = {
  display: 'none',
};

export const Badge = styled.View(({ theme }) => ({
  backgroundColor: theme.color['risk-high'],
  width: BASE_SIZE[24],
  height: BASE_SIZE[24],
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 100,
}));

export const Wrapper = styled.View(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
}));
interface DrawerTypeProps {
  drawerType: DrawerType;
}

export const useCommonDrawerProps = (): DrawerNavigationOptions &
  DrawerTypeProps => {
  const theme = useTheme();
  const drawerType = useDrawerType();
  const backgroundColor = theme.color.base;

  const headerShown = drawerType !== 'permanent';

  return {
    drawerType,
    drawerLabelStyle: {
      ...drawerLabelStyle,
      color: theme.color['text-subdued'],
    },
    headerTitleStyle: {
      ...headerTitleStyle,
      color: theme.color['text-subdued'],
    },
    headerShown,
    headerLeft: () => (
      <DrawerToggleButton tintColor={theme.color['text-subdued']} />
    ),
    headerTintColor: theme.color['text-default'],
    headerStyle: {
      backgroundColor,
      height: BASE_SIZE[48],
      borderBottomWidth: 0,
    },
    drawerStyle: {
      backgroundColor,
    },
    drawerActiveTintColor: theme.color.white,
    drawerActiveBackgroundColor: theme.color['primary-20'],
  };
};
